import React from 'react';
import RandomColor from '../../containers/RandomColor'
import '../app/main.css';

export default function App() {

  return <RandomColor/>;
  
}
